import React from 'react';

export function DonationTypeRadioButton(props) {
    const {
        listId,
        inputId,
        isOptionSelected,
        donationTypeValue,
        donationTypeName,
        updateDonationType } = props
    return <li key={donationTypeValue} id={listId}>
        <input
            id={inputId}
            className="customDonationTypeRadio"
            name="donationType"
            type="radio"
            // defaultChecked={isOptionSelected}
            checked={isOptionSelected}
            value={donationTypeValue}
            onClick={updateDonationType}
            readOnly
        />
        <label htmlFor={inputId} className="customDonationRadioLabel">
        &nbsp;&nbsp;&nbsp;{donationTypeName}
        </label>
    </li>
}